import ApiServices from '@/services/apiServices'

export class Proc extends ApiServices {
  constructor(url) {
    super(url)
  }

  getPermissions(params) {
    return this.http.get(`${this.baseURL}/permissions`, { params })
  }
}

export default new Proc('/roles')
